import React from "react"

export default function TypeConditionalTextarea({ value }) {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: value,
      }}
    />
  )
}
